import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Typography } from '@material-ui/core'

import useStyles from './styles'

const CourseCard = ({ course, isSelected, disabled, onSelect }) => {
  const classes = useStyles()

  const handleSelect = () => {
    if (disabled) return
    onSelect(course.id)
  }

  return (
    <Box
      className={clsx(classes.card, {
        [classes.cardSelected]: isSelected,
        [classes.cardDisabled]: disabled,
      })}
      onClick={handleSelect}
    >
      {course.thumbnailUrl ? (
        <Box
          component="img"
          src={course.thumbnailUrl}
          alt={course.title}
          className={classes.cover}
        />
      ) : (
        <Box className={classes.fallbackCover}>
          <Typography variant="subtitle1" className={classes.fallbackTitle}>
            {course.title}
          </Typography>
        </Box>
      )}
      <Box className={classes.footer}>
        <Typography variant="body2" className={classes.title}>
          {course.title}
        </Typography>
      </Box>
    </Box>
  )
}

CourseCard.propTypes = {
  course: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
}

export default CourseCard
